import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42eecaea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "registrationFee" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<article class=\"registrationFee__text\" data-v-42eecaea><h2 class=\"text__title\" data-v-42eecaea>INSCRIPCIÓN<br data-v-42eecaea>ENERO 2022</h2><p class=\"text__description\" data-v-42eecaea>Querés probar con un mes para ver como te va?<br data-v-42eecaea>O estás decidido a largo plazo? </p><p class=\"text__description\" data-v-42eecaea>Elegí entre abonar 1, 3 o 6 meses por adelantado.<br data-v-42eecaea>Mientras más comprometido estés, más descuento tenés!</p><p class=\"text__description\" data-v-42eecaea>Inscripción está abierta todo el año.<br data-v-42eecaea> Sumate hoy y hacé que 2022 sea el año que (por fin!) aprendés inglés. </p></article><article class=\"registrationFee__prices\" data-v-42eecaea><div class=\"prices__month\" data-v-42eecaea><p class=\"month__group\" data-v-42eecaea>1 MES<br data-v-42eecaea>CURSO GRUPAL</p><hr data-v-42eecaea><p class=\"month__price\" data-v-42eecaea>$ 5.400</p><hr data-v-42eecaea></div><div class=\"prices__month prices__month-popular\" data-v-42eecaea><p class=\"month__group\" data-v-42eecaea>3 MESES<br data-v-42eecaea>CURSO GRUPAL</p><hr data-v-42eecaea><p class=\"month__price\" data-v-42eecaea>$ 12.800</p><hr data-v-42eecaea><small id=\"popularSmall\" data-v-42eecaea>*mas popular*</small></div><div class=\"prices__month\" data-v-42eecaea><p class=\"month__group\" data-v-42eecaea>6 MESES<br data-v-42eecaea>CURSO GRUPAL</p><hr data-v-42eecaea><p class=\"month__price\" data-v-42eecaea>$ 22.700</p><hr data-v-42eecaea></div></article>", 2)
const _hoisted_4 = { class: "registrationFee__actionButton" }
const _hoisted_5 = { class: "actionButton__box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "¿Querés ver más información sobre los niveles, grupos y precios de Chatterbox?", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ver grupos y niveles ")
const _hoisted_8 = { class: "actionButton__box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "¿Te gustaría hacer una prueba rápida y on-line para saber cuál es tu nivel de Inglés en este momento?", -1))
const _hoisted_10 = { class: "actionButton__box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "¿Te gustaría probar una clase grupal gratuita para descubrir la escencia de Chatterbox?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("article", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_router_link, {
          to: { name: 'Classes' },
          class: "box__search"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("button", {
          id: "checkLevel",
          class: "box__checkLevel",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkLevel && _ctx.checkLevel(...args)))
        }, " comprueba tu nivel ")
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("button", {
          id: "testClass",
          class: "box__freeGroupClass",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startFreeClass && _ctx.startFreeClass(...args)))
        }, " prueba una clase ")
      ])
    ])
  ]))
}